import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert, Space } from 'antd';

const { Title, Text } = Typography;

const Preinscription = () => {
  const query = new URLSearchParams(window.location.search);
  const ref = query.get('ref');

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // success or error message
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    if (!ref) {
      setMessage({ type: 'error', text: "Le paramètre 'ref' est manquant dans l'URL." });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch(`http://localhost:8080/anonymes/preinscription?ref=${ref}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const text = await response.text();
      if (response.ok) {
        setMessage({ type: 'success', text: text || "Préinscription réussie !" });
        form.resetFields();
      } else {
        setMessage({ type: 'error', text });
      }
    } catch (error) {
      setMessage({ type: 'error', text: "Erreur lors de la préinscription." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: 450,
        margin: '3rem auto',
        padding: '2rem',
        borderRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Title level={2} style={{ color: '#1890ff', textAlign: 'center' }}>
        Bonjour !
      </Title>
      <Text
        style={{
          display: 'block',
          marginBottom: 24,
          textAlign: 'center',
          fontSize: 16,
          color: '#fa8c16', // orange
          fontWeight: 500,
        }}
      >
        Veuillez remplir le formulaire de préinscription
      </Text>

      {!ref && (
        <Alert
          message="Lien invalide : pas de référence trouvée."
          type="error"
          showIcon
          style={{ marginBottom: 24 }}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        disabled={loading || !ref}
        requiredMark={false}
      >
        <Form.Item
          label="Nom"
          name="nom"
          rules={[{ required: true, message: 'Veuillez saisir votre nom' }]}
        >
          <Input placeholder="Votre nom" />
        </Form.Item>

        <Form.Item
          label="Prénom"
          name="prenom"
          rules={[{ required: true, message: 'Veuillez saisir votre prénom' }]}
        >
          <Input placeholder="Votre prénom" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Veuillez saisir votre email' },
            { type: 'email', message: 'Email invalide' },
          ]}
        >
          <Input placeholder="exemple@mail.com" />
        </Form.Item>

        <Form.Item
          label="Téléphone"
          name="telephone"
          rules={[{ required: true, message: 'Veuillez saisir votre téléphone' }]}
        >
          <Input placeholder="+223 00 00 00 00" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            style={{
              backgroundColor: '#1890ff', // bleu principal
              borderColor: '#1890ff',
            }}
          >
            S’inscrire
          </Button>
        </Form.Item>
      </Form>

      {message && (
        <Alert
          style={{ marginTop: 20 }}
          message={message.text}
          type={message.type}
          showIcon
        />
      )}
    </div>
  );
};

export default Preinscription;
